import { gql } from "@apollo/client";
export default gql`
  query getPosInvoice($_id: String) {
    getPosInvoice(_id: $_id) {
      ok
      error
      data {
        _id
        docNo

        time
        opType
        title
        desc

        total
        discount
        amount

        amountPaid # cash
        amountPaid2 # card/bank
        refNo
        refType

        invoiceitems
        attachments

        customerId
        customerName
        customerNameAr

        stockId
        stockName
        stockNameAr

        userId

        createdAt
        updatedAt
      }
    }
  }
`;
